import {
  aRemoveTagFromInsight,
  mockRemoveTagFromInsightOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const removeTagFromInsightResponse = {
  __typename: 'Mutation' as const,
  removeTagFromInsight: aRemoveTagFromInsight(),
};

export const handlers = [
  mockRemoveTagFromInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: removeTagFromInsightResponse,
      });
    }
  ),
];
